// HTML pattern and server validation use the same character and digit limits.
export const PHONE_PATTERN = '(?=(?:[^0-9]*[0-9]){7,15}[^0-9]*$)[+\\(\\)0-9 .\\-]{7,50}';

const phoneRegex = new RegExp(`^(?:${PHONE_PATTERN})$`);

export function isValidPhone(value: string): boolean {
    return phoneRegex.test(value.trim());
}
